import { cn } from "@/utils/theme";

interface DotComponentProps {
  shouldShow?: boolean;
}
export const DotComponent = ({ shouldShow }: DotComponentProps) => {
  if (!shouldShow) return null;
  return (
    <div className="flex flex-col items-center self-stretch relative px-[5px]">
      <span className="flex-auto"></span>
      <div className="flex justify-center items-center">
        <span className="w-[10px] h-[10px] rounded-full bg-neutral-object-accent-loud border border-neutral"></span>
      </div>
      <span className="flex-auto"></span>
    </div>
  );
};

interface ParentLineComponentProps {
  leftPx?: number;
}
export const ParentLineComponent = ({
  leftPx = 9,
}: ParentLineComponentProps) => {
  return (
    <span
      className={cn(
        `bg-surface-action-accent-quiet border-neutral border-l-1 w-[1px] absolute top-[39px] z-10`,
        "h-[calc(95%-81px)]",
      )}
      style={{
        left: `${leftPx}px`,
      }}
    ></span>
  );
};

interface ConnectorComponentProps {
  isFirst?: boolean;
  isLast?: boolean;
}
export const ConnectorComponent = ({ isFirst, isLast }: ConnectorComponentProps) => {
  return (
    <div className="flex relative">
      <span className="flex-auto"></span>
      {isFirst ? (
        <span className="border-(--on-disabled-text-quiet) dark:border-(--border-neutral) border-l-1 border-b-1 h-[105%] w-[12px] rounded-bl-lg absolute -top-[55%] left-[-7px]"></span>
      ) : isLast ? (
        <span className="border-(--on-disabled-text-quiet) dark:border-(--border-neutral) border-l-1 border-b-1 h-[150%] w-[12px] rounded-bl-lg absolute -top-[100%] left-[-7px]"></span>
      ): (
        <span className="border-(--on-disabled-text-quiet) dark:border-(--border-neutral) border-l-1 border-b-1 h-[50%] w-[12px] rounded-bl-lg absolute top-[0%] left-[-7px]"></span>
      )}
      <span className="flex-auto"></span>
    </div>
  );
};
